import { FrameDetailInfoFragment } from '@sketch/gql-types'

// Minimal type that covers only the fields we need for thumbnails
type File = Pick<FrameDetailInfoFragment['files']['0'], 'url' | 'thumbnails'>

// This allows the function to work with any object that has the files structure we need
type FrameWithThumbnail = {
  files?: Array<File> | null
}

export const getFrameThumbnail = (
  frame?: FrameWithThumbnail,
  type: 'L' | 'M' | 'S' | 'XL' = 'L'
) => {
  const file = frame?.files?.[0]

  const thumbnails = file?.thumbnails ?? []
  const thumbnail = thumbnails.find(t => t?.type === type)

  return (thumbnail || file)?.url ?? ''
}
